angular.module('org.saga.newinstance', [
   'org.saga.service'
])

   .controller('NewInstanceController', ['$scope', '$log', 'Model', 'NewInstance',
      function($scope, $log, Model, NewInstance) {

         $scope.tableHeader = 'Type of Instance';

         Model.manual(function(models) {
            $scope.models = models;
         });

         $scope.setModel = function(model) {
            NewInstance.run(model, function(url) {
               location.href = url;
            });
         };

      }]);

